module.exports = __webpack_public_path__ + "static/media/GreenlandCopter_2026_Logo.0a5f71df.png";